function resize($window) {
    return function (scope, element) {
        scope.getWindowDimensions = function () {
            return {
                'h': $window.innerHeight,
                'w': $window.innerWidth
            };
        };
        scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
            scope.windowHeight = newValue.h;
            scope.windowWidth = newValue.w;

            scope.style = function (dw, dh, maxWidth) {
                return {
                    'height': (newValue.h - dh) + 'px',
                    'width': Math.min(newValue.w - dw, maxWidth) + 'px'
                };
            };

        }, true);
        var w = angular.element($window);
        w.bind('resize', function () {
            scope.$apply();
        });
    };
};

export default resize;



// WEBPACK FOOTER //
// ./src/login/termscond/resize.js